import {
  Directive,
  inject,
  input,
  TemplateRef,
  ViewContainerRef,
} from '@angular/core';

@Directive({
  selector: '[vKfName]',
})
export class VKratosFormFieldDirective {
  vKfName = input<string>();
  vKfFormFieldHeader = input<TemplateRef<any> | null>(null);

  public vcr = inject(ViewContainerRef);
}
